import type { NocStatus } from '../shared/api';
import type { Tone } from './format';

export const NOC_STATUS_LABELS: Record<NocStatus, string> = {
  not_started: 'NOC Not Started',
  awaiting_notarization: 'Awaiting Notarization',
  notarized: 'Notarized — Record at Clerk',
  recorded: 'Recorded',
};

/**
 * 'awaiting_notarization' is amber rather than neutral on purpose: paper exists
 * but no notarial act has happened, and F.S. 713.13(1)(g) needs one. A calm
 * colour there would read as "done".
 */
export const NOC_STATUS_TONE: Record<NocStatus, Tone> = {
  not_started: 'none',
  awaiting_notarization: 'watch',
  notarized: 'info',
  recorded: 'ok',
};
